import React, { useState, useRef } from "react";
import Widget from "../../widget/Widget";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import Table from "react-virtualized/dist/commonjs/Table";
import Column from "react-virtualized/dist/commonjs/Table/Column";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ActionIcon from "@mui/icons-material/MoreHoriz";
import WidgetTagsConfigureDialog from "components/widget/widget-configure-dialogs/widget-tags-configure-dialog/WidgetTagsConfigureDialog";
import Replay from "@mui/icons-material/Replay";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import GetAppIcon from "@mui/icons-material/GetApp";
import FileCopyIcon from '@mui/icons-material/FileCopy';
const ISO_DAYS_OF_WEEK = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
const uuidv4 = require("uuid/v4");
const timelengthmap = { "day": 1, "week": 7, "month": 30 }
function timeLabel(ts) {
  //stamp to label
  try {
    const date = new Date(ts)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
      //hour: date.getHours() !== 0 || date.getMinutes() !== 0 ? 'numeric' : undefined,
      //minute: date.getMinutes() !== 0 ? '2-digit' : undefined
    });
    //toISOString();
  } catch {
    return "";
  }
}

const recurLableMap = { "1": "Daily", "7": "Weekly", "0": "Other" };
const ExportLink = ({ props }) => {
  const expire =
    parseFloat(props.expire) ||
    parseFloat(props.end_time) + 7 * 24 * 3600 * 1000;
  if (props.url)
    return Date.now() > expire ? (
      <div>Expired</div>
    ) : (
      <a target="_blank" rel="noopener noreferrer" href={props.url}>
        Click
      </a>
    );
  return <div></div>;
};

const handleDownload = (url) => {
  const link = document.createElement("a");
  link.href = url; // replace with your file path or URL
  link.download = "Export.zip";    // suggested filename 
  link.click();
};

const _rowStyle = ({ index }) => {
  let style = { borderBottom: "1px solid #e0e0e0" };
  if (index < 0) {
    style.textTransform = "none";
  } else if (index % 2 === 0) {
    // won't see border without this
    style.zIndex = 1;
  } else {
    style.backgroundColor = "#fafafa";
  }
  return style;
};


export const ACTION_NONE = -1;
export const ACTION_EDIT = 1;
export const ACTION_DUPLICATE = 2;
export const ACTION_DOWNLOAD = 3;
export const ACTION_DELETE = 4;
export const ACTION_REMOVE = 5;
const EXPORT_RECUR_ACTIONS = () => [
  {
    id: 1,
    label: "Edit",
    icon: Edit,
  },
  {
    id: 2,
    label: "Duplicate",
    icon: FileCopyIcon,
  },
  {
    id: 4,
    label: "Delete",
    icon: Delete,
  },
];

const EXPORT_ACTIONS = () => [
  {
    id: 3,
    label: "Download",
    icon: GetAppIcon,
  },
  {
    id: 2,
    label: "Resubmit",
    icon: Replay,
  },
  {
    id: 5,
    label: "Delete",
    icon: Delete,
  },
];

const ExportWidget = (props) => {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportDialogTitle, setExportDialogTitle] = useState("");
  const [exportMenuAnchor, setExportMenuAnchor] = useState(false);
  const [exportCat, setExportCat] = useState(2);
  const [action, setAction] = useState(0);
  const selectedExport = useRef(null);
  //completed:
  // sort by 'request_time'
  // start_time, end_time
  // status
  // tags[]
  // url
  const recurringData = props.data && props.data.filter((s) => (s.status === "recurring" || (s.status === "requested" && s?.options?.recur === "1"))).sort((b, a) => a.request_time - b.request_time);
  const sortedData =
    props.data && props.data.filter((s) => s.status !== "recurring").sort((b, a) => a.request_time - b.request_time);
  //console.log("recurring and sorted",recurringData,sortedData);
  //pending:
  //options.start: timestamp of start of data range
  //options.end: timestamp of end of data range
  //options.include-errtok: flag to include errtok values (defaults to false)
  //options.include-header: flag to include header in csv
  //options.one-file: flag to combine all tags to a single file
  function updateWidget(opts) {
    //console.log("options for export tool are", opts);
    const getslots = (prs) => {
      return prs.map((p) => {
        const cp = p?.tunits[0];
        const weekbitmap = (cp?.byweekday ?? [])
          .map((d) => Math.pow(2, ISO_DAYS_OF_WEEK.indexOf(d)))
          .reduce((a, b) => a + b, 0);
        //console.log("cp and weekbitmap",cp?.byweekday,weekbitmap);
        return `${weekbitmap}_${cp?.start ?? 0}_${(cp?.start ?? 0) + (cp?.["duration.value"] ?? 24) * 3600000
          }`;
      });
    };
    function convertDT(dateTimeString) {
      const date = new Date(dateTimeString);
      if (isNaN(date)) {
        throw new Error("Invalid date-time string");
      }
      date.setSeconds(0);
      date.setMilliseconds(0);
      //console.log("date is",date,Math.floor(date.getTime()))
      return Math.floor(date.getTime());
    }
    //convert tag names and start end
    //const options = {...opts.options};

    const options = {
      "data-format": opts.options?.["data-format"],
      "email": opts.options?.["email"],
      "email-tables": opts.options?.["email-tables"],
      "fname": opts.options?.["fname"],
      "include-header": opts.options?.["include-header"],
      "sort-alpha": opts.options?.["sort-alpha"],
      "emailattachment": opts.options?.["emailattachment"] ? "csv" : false,
      "note": opts.options?.["note"],
      "one-file": opts.options?.["one-file"],
      "recur": opts.options?.["recur"],
      "timezone": opts.options?.["timezone"],
      "timerange": opts.options?.["timerange"],
      "startofweek": opts.options?.["startofweek"],
      "periodids": opts.options?.["periodids"],
      "periods": opts.options?.["periods"],
      "frequency-type": opts.options?.["frequency-type"],
      "beginat": opts.options?.["beginat"],
      "lookbackamount": opts.options?.["lookbackamount"],
      "lookbackunit": opts.options?.["lookbackunit"],
      "forwardamount": opts.options?.["forwardamount"],
      "forwardunit": opts.options?.["forwardunit"],
    }
    options.slots = getslots(opts.options?.periods || "");
    options.summaryoptions = Object.fromEntries(
      Object.values(opts.options["periods.tracking"] ?? {}).map((x) => [x.key, x])
    );
    console.log("slots and timezone are", options);
    /*if (options?.timeframe?.type === "moving") {
      options.start = new Date().setHours(0, 0, 0, 0);
      options.end = options.start + (options?.timeframe?.['length.value'] * timelengthmap[options?.timeframe?.['length.units']]*86400000)
      options["recur-days"] = timelengthmap[options?.timeframe?.['length.units']]
    }
    else {
      if (options?.timeframe?.start) {
        options.start = convertDT(options?.timeframe?.start);
        options.end = convertDT(options?.timeframe?.end);
      }
    }*/
    if (options["time-sensitivity"]) {
      options["time-sensitivity"] = parseInt(options["time-sensitivity"]) || 0;
    }
    if (options?.recur === "0") {
      options.start = opts.options?.fixedstart
      options.end = opts.options?.fixedend
    }
    else {
      options.start = opts.options?.recurstart
      options.end = opts.options?.recurend
      options["execute-after"] = opts.options?.["execute-after"]
      options["recur-days"] = opts.options?.["recur-days"]
    }
    const body = {
      tags: opts.tags.map((t) => t.stack + "_" + t.attribute),
      options: options,
    };
    console.log("req body", action, body);
    if (action === ACTION_EDIT && selectedExport.current?.request_time) {
      //console.log("delete old recurrence",selectedExport.current?.request_time);
      removeExportRequests(selectedExport.current?.request_time);
      selectedExport.current = null;
    }
    props.newRequest(body);

  }

  const getName = (op) => {
    const nm = op?.fname ?? ""
    const note = op?.note ?? ""
    if (nm && note) {
      return nm + " | " + note
    }
    if (nm) {
      return nm
    }
    if (note) {
      return note
    }
    return "Unnamed"
  }

  function removeExportRequests(request_time) {
    props.removeExport(request_time);
  }

  function removeExportCompleted(request_time, guuid) {
    props.removeExport(request_time, guuid);
  }

  const handleAction = (action) => {
    console.log("action is", action, exportCat, selectedExport);
    if (action?.id && selectedExport.current) {
      setAction(action.id);
      switch (action.id) {
        case ACTION_EDIT:
          setExportDialogOpen(true);
          break;
        case ACTION_DUPLICATE:
          setExportDialogOpen(true);
          break;
        case ACTION_DOWNLOAD:
          handleDownload(selectedExport.current?.url)
          break;
        case ACTION_DELETE:
          removeExportRequests(selectedExport.current?.request_time, selectedExport.current?.guuid);
          break;
        case ACTION_REMOVE:
          removeExportCompleted(selectedExport.current?.request_time, selectedExport.current?.guuid);
          break;
      }
    }
  }

  //Need some sort of flex container here so table stays in widget

  return (
    <>
      <Widget {...props} configurable={false}>
        <div
          style={{ width: "100%", height: "100%" }}
          onClick={(ev) => {
            // stop propagation so this stack remains selected
            ev.stopPropagation();
          }}
        >
          <Card style={{ height: "100%" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginLeft: "1rem",
                marginRight: "1rem",
                marginTop: "1rem",
              }}
            >
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  selectedExport.current = null;
                  setAction(0);
                  setExportDialogTitle("New Export Request");
                  setExportDialogOpen(true);
                }}
                style={{
                  fontSize: "0.825rem",
                  textTransform: "none",
                }}
              >
                New Export Request
              </Button>
            </div>
            <CardContent style={{ height: "calc(100% - 31px)" }}>
              <div style={{ fontWeight: "bold", marginTop: 20, marginBottom: 10 }}>Scheduled Exports</div>
              <div style={{ marginTop: 0, height: "30%" }}>
                {recurringData && (
                  <AutoSizer>
                    {({ width, height }) => (
                      <Table
                        width={width}
                        height={height}
                        headerHeight={30}
                        rowHeight={30}
                        rowCount={recurringData.length}
                        rowGetter={({ index }) => recurringData[index] || []}
                        rowStyle={_rowStyle}
                      >
                        <Column
                          dataKey=""
                          label="Recurrence"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {recurLableMap[rowData.options?.["recur-days"] ?? "0"]}
                            </div>
                          )}
                          width={110}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Details"
                          cellRenderer={({ rowData }) => getName(rowData.options)}
                          //cellRenderer={({ rowData }) => ((rowData.options?.name ?? "") + ((rowData.options?.name && rowData.options?.note) ? " | " : "") + (rowData.options?.note ?? "")) }
                          width={610}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Next Export At"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData.options?.["execute-after"]
                                || rowData.options?.end
                                || rowData.request_time
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Actions"
                          cellRenderer={({ rowData }) => (
                            <IconButton
                              title="Click for menu of actions"
                              onClick={(e) => {
                                selectedExport.current = rowData;
                                setExportCat(1)
                                setExportMenuAnchor(e.currentTarget);
                              }}
                              style={{ padding: 6 }}
                            >
                              <ActionIcon />
                            </IconButton>
                          )}
                          width={90}
                          flexGrow={0}
                        />
                      </Table>
                    )}
                  </AutoSizer>
                )}
                {!props.data && (
                  <div>No export jobs. Use settings to create.</div>
                )}
              </div>
              <div style={{ fontWeight: "bold", marginTop: 20, marginBottom: 10 }}>Export Queue</div>
              <div style={{ marginTop: 0, height: "100%" }}>
                {sortedData && (
                  <AutoSizer>
                    {({ width, height }) => (
                      <Table
                        width={width}
                        height={height}
                        headerHeight={30}
                        rowHeight={30}
                        rowCount={sortedData.length}
                        rowGetter={({ index }) => sortedData[index] || []}
                        rowStyle={_rowStyle}
                      >
                        <Column
                          dataKey=""
                          label="Status"
                          cellRenderer={({ rowData }) =>

                            (rowData.expire && Date.now() > rowData.expire) ? "Expired" : (rowData.status === "finished" ? "Complete" : rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1))

                          }
                          width={110}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Details"
                          cellRenderer={({ rowData }) => getName(rowData.options)}
                          //cellRenderer={({ rowData }) => ((rowData.options?.name ?? "") + ((rowData.options?.name && rowData.options?.note) ? " | " : "") + (rowData.options?.note ?? "")) }
                          width={400}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Data Window Start"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData?.options?.start
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Data Window End"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData?.options?.end
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Actions"
                          /*cellRenderer={({ rowData }) => (
                            <ExportLink props={rowData} />
                          )}*/
                          cellRenderer={({ rowData }) => (
                            <IconButton
                              title="Click for menu of actions"
                              onClick={(e) => {
                                setExportCat(2)
                                selectedExport.current = rowData;
                                setExportMenuAnchor(e.currentTarget);
                              }}
                              style={{ padding: 6 }}
                            >
                              <ActionIcon />
                            </IconButton>
                          )}
                          width={90}
                          flexGrow={0}
                        />
                      </Table>
                    )}
                  </AutoSizer>
                )}
                {!props.data && (
                  <div>No export jobs. Use settings to create.</div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
        {exportDialogOpen && (
          <WidgetTagsConfigureDialog
            {...props}
            widget={{
              tags: selectedExport.current ? selectedExport.current?.tags.map((t) => {
                const sepidx = t.indexOf('_')
                return { 'stack': t.slice(0, sepidx), 'attribute': t.slice(sepidx + 1), 'guuid': uuidv4() }
              }) : [],
              //tags: [],
              options: selectedExport.current ? selectedExport.current?.options : {},
            }}
            updateWidget={updateWidget}
            open={exportDialogOpen}
            removeDialog={() => setExportDialogOpen(false)}
            dialogTitle={exportDialogTitle}
            dialogText={"Select the stack and tags from which you would like to export data. Note that export requests are processed as compute is available; They will not appear immediately."}
            options={[
              {
                type: "export",
                default: {
                  //"include-header": true,
                  //"sort-alpha":true,
                  "emailattachment": false,
                  //"one-file":true,
                  "data-format": "1",
                  "beginat": "0",
                  "frequency-type": "daily"
                }
              },
              {
                type: "timezone"
              },
              {
                type: "timeframerecur",
                default: {
                  hide_type_toggle: true,
                  "recur": "0",
                  "timerange": "day",
                  "startofweek": "MO"
                },
              },
              {
                type: "periods",
                includeStacks: true,
                default: {
                  periods: [],
                  periods_to_show: 1,
                  hide_num_periods: true,
                  ignore_period_match: true,
                },
              },
              { type: "exportpreview", },
              {
                type: "periodreporting",
                includeStacks: true,
                default: {
                  "periods.tracking": "counts",
                  statereporting: {
                    states: [
                      {
                        id: 1,
                        label: "Off",
                        lowerBound: "0",
                        upperBound: "15",
                        minDuration: "5",
                        color: "",
                      },
                      {
                        id: 2,
                        label: "On",
                        lowerBound: "10",
                        upperBound: "100",
                        minDuration: "10",
                        color: "",
                      },
                    ],
                  },
                },
              }
            ]}
          />
        )}
      </Widget>
      <Menu
        id="export-menu"
        anchorEl={exportMenuAnchor}
        keepMounted
        open={Boolean(exportMenuAnchor)}
        onClose={() => setExportMenuAnchor(null)}
      >
        {
          (exportCat === 1 ? EXPORT_RECUR_ACTIONS() : EXPORT_ACTIONS()).map((action) => (
            <MenuItem
              disabled={action?.id === ACTION_DOWNLOAD && (selectedExport.current?.status !== "finished" || (selectedExport.current?.status === "finished" && selectedExport.current?.expire && Date.now() > selectedExport.current?.expire))}
              onClick={() => {
                setExportMenuAnchor(null);
                handleAction(action);
              }}
            >
              <ListItemIcon>
                <action.icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={action.label} />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default ExportWidget;
